/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const setCustomerOfferCoefficientRequestCoefficientExclusiveMin = 0;

export const SetCustomerOfferCoefficientRequest = zod.object({
  coefficient: zod
    .number()
    .gt(setCustomerOfferCoefficientRequestCoefficientExclusiveMin)
    .describe(
      "Protected admitted decision, strictly positive with no maximum-one cap or clamping. Never supplied through authored chapter content.",
    ),
});

export type SetCustomerOfferCoefficientRequest = zod.input<
  typeof SetCustomerOfferCoefficientRequest
>;
export type SetCustomerOfferCoefficientRequestOutput = zod.output<
  typeof SetCustomerOfferCoefficientRequest
>;
